import { Routes } from '@angular/router';
import { Role } from '@shared/enums/role.enum';
import { authGuard } from '@shared/guards/auth.guard';
import { rolesGuard } from '@shared/guards/roles.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login'
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/auth/login.routes').then((m) => m.routes),
  },
  {
    path: 'sales',
    canActivate: [authGuard, rolesGuard],
    data: { roles: [Role.SalesAdmin, Role.SalesManager, Role.SalesConciliator, Role.SalesObserver] },

    loadComponent: () =>
      import('./core/home/home.component').then((m) => m.HomeComponent),
      children: [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'dashboard'
        },
        {
          path: 'dashboard',
          loadChildren: () => import('./modules/dashboard/dashboard.routes').then((m) => m.routes),
        },
        {
          path: 'sales-request',
          canActivate: [authGuard, rolesGuard],
          data: { roles: [Role.SalesAdmin, Role.SalesManager, Role.SalesConciliator] },
          loadChildren: () => import('./modules/sales-request/sales-request.routes').then((m) => m.routes),
        },
        {
          path: 'sales-monitoring',
          loadChildren: () => import('./modules/sales-monitoring/sales-monitoring.routing').then((m) => m.routes),
        },
        {
          path: 'tef',
          loadChildren: () => import('./modules/tef/tef.routes').then((m) => m.routes),
        },
      ]
  },
];
